import { LockKeyhole, ShieldAlert } from "lucide-react";
import { useSiteBranding } from "@/context/SiteContext";

export const SignatureInviteOnlyLandingPage = ({ branding, dashboardPath, inviteOnlyMessage }) => {
  const { getWhatsAppHref } = useSiteBranding();

  return (
  <section className="section-shell py-10 md:py-14" data-testid="signature-invite-only-page">
    <div className="relative overflow-hidden rounded-[40px] border border-[#D4AF37]/20 bg-[linear-gradient(180deg,rgba(212,175,55,0.06)_0%,rgba(255,255,255,0)_48%)] p-[1px] shadow-[0_34px_90px_rgba(90,75,53,0.16)]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(212,175,55,0.14),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(26,26,26,0.08),transparent_28%)]" />
      <div className="relative overflow-hidden rounded-[39px] bg-[linear-gradient(145deg,#171717_0%,#1A1A1A_52%,#222222_100%)] px-6 py-10 text-[#F6F1E9] md:px-10 md:py-14">
      <div className="grid gap-8 lg:grid-cols-[1.2fr_0.8fr] lg:items-end">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37]" data-testid="signature-invite-only-kicker">Signature Portal • Private Showroom</p>
          <h1 className="mt-5 font-[Cormorant_Garamond,serif] text-5xl font-bold leading-none md:text-6xl" data-testid="signature-invite-only-heading">
            {branding.name}'s boutique portal is finished, but not public yet.
          </h1>
          <p className="mt-5 inline-flex rounded-full border border-[#D4AF37]/18 bg-[#D4AF37]/10 px-4 py-2 text-sm font-semibold tracking-[0.12em] text-[#D4AF37] shadow-[0_10px_30px_rgba(212,175,55,0.12)]" data-testid="signature-invite-only-status-pill">
            Private Showroom
          </p>
          <p className="mt-5 max-w-3xl text-base leading-8 text-[#F6F1E9]/78" data-testid="signature-invite-only-copy">
            {inviteOnlyMessage || "This Ambassador path is locked behind a compliance shield until activation payment is completed inside the private cockpit."}
          </p>
          <div className="mt-5 inline-flex rounded-full border border-[#D4AF37]/18 bg-[#2A2724] px-4 py-2 text-xs font-semibold tracking-[0.16em] text-[#F6F1E9] shadow-[0_12px_28px_rgba(22,18,11,0.22)]" data-testid="signature-invite-only-listing-status-pill">
            Listings are staged, hidden from the marketplace, and ready to publish.
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <a className="gold-button" data-testid="signature-invite-only-dashboard-button" href={dashboardPath || "/admin/login"}>
              Open private dashboard
            </a>
            <a className="outline-button !border-[#D4AF37]/22 !bg-white/5 !text-[#F6F1E9] hover:!bg-white/10" data-testid="signature-invite-only-whatsapp-button" href={getWhatsAppHref("Hello, I need access help for this private showroom.")} rel="noreferrer" target="_blank">
              Request access help
            </a>
          </div>
        </div>

        <div className="rounded-[32px] border border-[#D4AF37]/16 bg-[#1f1f1f]/92 p-6 backdrop-blur" data-testid="signature-invite-only-side-panel">
          <div className="rounded-[24px] border border-[#D4AF37]/18 bg-[#2A2724] p-5 text-[#F6F1E9]">
            <LockKeyhole className="h-5 w-5 text-[#D4AF37]" />
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Launch gate</p>
            <p className="mt-3 text-2xl font-semibold">Activation payment required</p>
          </div>
          <div className="mt-4 rounded-[24px] border border-white/10 bg-[#151515] p-5">
            <ShieldAlert className="h-5 w-5 text-[#D4AF37]" />
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Public status</p>
            <p className="mt-3 text-lg font-semibold">/agent/{branding.subdomain_slug || "portal"}</p>
            <p className="mt-3 text-sm leading-7 text-[#B8B0A5]">Listings stay hidden from the public marketplace until the showroom is activated and published.</p>
          </div>
        </div>
      </div>
      </div>
    </div>
  </section>
  );
};